import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamDataAction } from '../../analyticData/fetchTeamData/action';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';
import { backendClient } from '../../../../services/api/backend-client';

export function* updateTeamMemberSaga(action) {
    const { teamId, uid, excluded, role, range = 'week' } = action.payload || {};

    try {
        if (!teamId) throw new Error("teamId is required");
        if (!uid) throw new Error("uid is required");

        const body = {};
        if (excluded !== undefined) body.excluded = excluded;
        if (role !== undefined) body.role = role;

        yield call(
            [backendClient, backendClient.patch],
            `teams/${encodeURIComponent(teamId)}/members/${encodeURIComponent(uid)}`,
            body
        );

        yield put(fetchAnalyticTeamDataAction({ teamId, range }));

        if (excluded !== undefined) {
            yield put(showSnackbar({
                message: excluded
                    ? "Your calls are now hidden from this team."
                    : "Your calls are now included in this team.",
                severity: "success",
            }));
        }
    } catch (err) {
        bugsnagClient.notify(err);
        console.error("Failed to update analytic team member:", err?.message);
        yield put(showSnackbar({ message: "Failed to update team member.", severity: "error" }));
    }
}
